export default __webpack_public_path__ + "static/media/Icon_Add_to_Cart.58b87a9b.svg";